import React from "react";
import { FormLabel } from "react-bootstrap";

const CustomLabel = ({ htmlFor = "", label = "" , classname ="" }) => {
  return <FormLabel htmlFor={htmlFor} className={classname}>{label}</FormLabel>;
};

export default CustomLabel;
